<template>
    <div
    	v-if="enabled" 
    	class="filters-container chart-filters" 
    	>
        <div class="dropdown-filters" id="dropdown-filters">

        	<DataviewFiltersDropdowns 
        		v-if="dropdownFilters.length"
	        		:dtPost="chartData.post"
	        		:tableFilters="dropdownFilters"
	        		:feTheme="feTheme"
	        		:side="false"
	        		@filterSubmit="ddFilterSubmit"
	        	/>

        </div>

        <template v-if="dateFilters">
		    <DataviewFiltersDatepicker 
		    	:dtPost="chartData.post"
		    	:feTheme="feTheme"
		    	:dateFilters="dateFilters"
		    	@dateUpdate="dateFilterSubmit"
		    />
		</template>

        <!-- {% if vw and filters_position == 'filters-position-top' %}
            {% include 'common/_view-wrapper-toggle.twig' %}
        {% endif %} -->

    </div><!--/.filters-container-->

</template>


<script>

import DataviewFiltersDatepicker from '@vueapp/components/dataviews/DataviewFiltersDatepicker.vue'
import DataviewFiltersDropdowns from '@vueapp/components/dataviews/DataviewFiltersDropdowns.vue'

export default {
	name: 'ChartFiltersComponent',
	components: { DataviewFiltersDatepicker, DataviewFiltersDropdowns },
	props: {
		chartData: {
			type: Object,
			default: {}
		},
		filterOptions: {
			type: Array,
			default: [],
		},
		search: {
			type: Boolean,
			default: false
		},
		dropdownFilters: {
			type: Array,
			default: []
		},
		dateFilters: {
			type: Object,
			default: null,
		},
		feTheme: {
			type: Object,
			default: {}
		}
	},
	emits: ['filters-submit'],
	data() {
		return {
			filters: {}
		}
	},

	methods: {
		dateFilterSubmit( range ) {
			let payload = {'time-interval': !range || 2 != range.length ? [this.start_date, this.end_date] : ( range.map( item => item/1000) ).join('|') }
			this.filters = { ...this.filters, ...payload }
			this.$emit('filters-submit', this.filters)    		
		},
		ddFilterSubmit(e) {
			this.filters[e.filterKey] = e.filterValue
			this.$emit('filters-submit', this.filters)
    	},
	},

	computed: {
		enabled() {
			// if ( ( this.chartData.post.dropdown_filters && this.chartData.post.dropdown_filters != 0 ) || this.chartData.post.date_filter  ) {
			// 	// console.log(this.chartData.type, this.dropdownFilters)				
			// }
			return this.dropdownFilters || this.dateFilters
		}
	}
}
</script>